import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularMaterialModule } from '../shared/module/angular-material.module';

import { IssuesWidgetComponent } from './issues-widget/issues-widget.component';
import { IssueRowComponent } from './shared/issue-row/issue-row.component';
import { IssueCardExpandedComponent } from './issues-widget/issue-card-expanded/issue-card-expanded.component';
import { IssueDetailComponent } from './shared/issue-detail/issue-detail.component';
import { EvidenceCardComponent } from './shared/evidence-card/evidence-card.component';
import { ConfidenceChartComponent } from './shared/confidence-chart/confidence-chart.component';
import { SeverityTagComponent } from './shared/severity-tag/severity-tag.component';
import { LifecycleChipComponent } from './shared/lifecycle-chip/lifecycle-chip.component';
import { IssueTagsComponent } from './shared/issue-tags/issue-tags.component';
import { OwnerAvatarComponent } from './shared/owner-avatar/owner-avatar.component';
import { AlertCaseComponent } from '../diagnostics/component/alert-case/alert-case.component';
import { SuppressDialogComponent } from './shared/suppress-dialog/suppress-dialog.component';
import {
  FaultHistoryDialogComponent,
} from './shared/fault-history-dialog/fault-history-dialog.component';
import { IssueRelativeTimePipe } from './issue-relative-time.pipe';

// Issues feature: the Vehicle Detail Summary widget — a flat accordion whose
// rows expand in place into the full issue detail card. Imported by
// VehicleDetailModule.
@NgModule({
  declarations: [
    IssuesWidgetComponent,
    IssueRowComponent,
    IssueCardExpandedComponent,
    IssueDetailComponent,
    EvidenceCardComponent,
    ConfidenceChartComponent,
    SeverityTagComponent,
    LifecycleChipComponent,
    IssueTagsComponent,
    OwnerAvatarComponent,
    SuppressDialogComponent,
    FaultHistoryDialogComponent,
    IssueRelativeTimePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    // The detail links to the asset. Without this, routerLink is not a known attribute and
    // an href silently takes its place — which reloads the whole application instead of
    // routing, and the reader loses the sheet they were working.
    RouterModule,
    TranslateModule,
    AngularMaterialModule,
    // Standalone case workflow component, embedded in the expanded issue card.
    AlertCaseComponent,
  ],
  exports: [
    IssuesWidgetComponent,
    // Exported so the fleet surfaces can render the same row and the same detail the
    // vehicle widget does. One Issue has to look the same everywhere it appears, which
    // it cannot if each surface builds its own.
    IssueRowComponent,
    IssueDetailComponent,
    IssueRelativeTimePipe,
  ],
})
export class IssuesModule {}
